import { useState, useEffect, useCallback } from 'react';
import constate from 'constate';
import { type RouteComponentProps, useLocation } from 'react-router-dom';
import history from 'routing/history';
import { PURCHASE_STEP_ORDER } from './consts';

export type UseStepNavigationProps = {
  flowPath: RouteComponentProps['match']['path'];
};

const useStepNavigation = ({ flowPath }: UseStepNavigationProps) => {
  const location = useLocation();
  const [stepNumber, setStepNumber] = useState(0);

  const stepsLength = PURCHASE_STEP_ORDER.length;

  const isRenewal = flowPath.includes('renew');

  const changeStep = useCallback(
    (stepDelta: number) => {
      if (stepDelta > 0 && stepNumber === stepsLength - 1) {
        return;
      }
      if (stepDelta < 0 && stepNumber === 0) {
        window.location.href = '/dashboard/nomad-insurance';
        return;
      }
      history.push(`${flowPath}/${PURCHASE_STEP_ORDER[stepNumber + stepDelta]}`);
    },
    [stepNumber, stepsLength, flowPath]
  );

  const jumpToStep = useCallback(
    (step: string) => {
      history.push(`${flowPath}/${step}`);
    },
    [flowPath]
  );

  const jumpToFirstStep = useCallback(() => {
    jumpToStep(PURCHASE_STEP_ORDER[0]);
  }, [jumpToStep]);

  useEffect(() => {
    setStepNumber(
      PURCHASE_STEP_ORDER.indexOf(location.pathname.replace(`${flowPath}/`, ''))
    );
  }, [location.pathname, flowPath]);

  return { stepNumber, stepsLength, changeStep, jumpToFirstStep, jumpToStep, isRenewal };
};

export const [StepNavigationProvider, useStepNavigationContext] =
  constate(useStepNavigation);
